import { api } from './client';

export interface RconPreset {
  label: string;
  command: string;
}

export const sendRconCommand = (id: string, command: string): Promise<{ output: string }> =>
  api.post<{ output: string }>(`/games/${id}/rcon/command`, { command }).then((r) => r.data);

export const fetchRconPresets = (id: string): Promise<{ presets: RconPreset[] }> =>
  api.get<{ presets: RconPreset[] }>(`/games/${id}/rcon/presets`).then((r) => r.data);

export const saveRconPresets = (id: string, presets: RconPreset[]): Promise<{ ok: boolean; presets: RconPreset[] }> =>
  api.put<{ ok: boolean; presets: RconPreset[] }>(`/games/${id}/rcon/presets`, { presets }).then((r) => r.data);
